import { render, staticRenderFns } from "./template.html?vue&type=template&id=2bbfa9a7&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=2bbfa9a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfa9a7",
  null
  
)

export default component.exports